import moment from 'moment';

export const DEFAULT_BIRTHDAY = moment('01 01 1950');
